import { createSlice } from '@reduxjs/toolkit'

export const publishersSlice = createSlice({
  name: 'publishers',
  initialState: {
    value: [],
  },
  reducers: {
    setall: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { setall } = publishersSlice.actions

export default publishersSlice.reducer